import { createFileRoute } from "@tanstack/react-router";
import { ProjektledelsePage, projektledelseHead } from "@/pages/ProjektledelsePage";

export const Route = createFileRoute("/projektledelse")({
  head: () => projektledelseHead("da"),
  component: () => <ProjektledelsePage locale="da" />,
});
